<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-10 col-lg-11 col-md-12 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Recipes</h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
            <soft-button
              v-if="isMichiganRegionUser == true"
              @click="$router.push({ name: 'CreateRecipe', params: { lineId: lineId } })"
            >
              Create New Recipe
            </soft-button>
          </div>

          <div class="mx-auto col-xl-10 col-lg-11 col-md-12 d-flex flex-column card card-body blur shadow-blur">
            <div class="card-header row">
              <h4
                v-if="selected_hopper === null"
                class="text-center mt-1 ms-4"
              >
                Select Hopper
              </h4>
              <label
                v-if="selected_hopper !== null"
                class="mt-2 mb-2"
              >
                Selected Hopper
              </label>
              <div
                class="mt-2 mb-2"
                :style="{
                  position: 'relative',
                  pointerEvents: hoppers.length === 1 ? 'none' : 'auto',
                }"
                @click.stop="
                  hoppers.length > 1 && (hopperDropdownVisible = !hopperDropdownVisible);
                  recipeDropdownVisible = false;
                "
              >
                <button class="form-control">
                  {{
                    selected_hopper
                      ? selected_hopper.name
                      : hoppers.length > 0
                        ? "Click here to select a Hopper"
                        : "No Hoppers to select"
                  }}
                </button>
                <div
                  v-if="hopperDropdownVisible"
                  class="dropdown-menu show w-100"
                  style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)"
                >
                  <input
                    v-model="searchQueryHopper"
                    class="form-control mt-1 mb-2 ms-2 w-90"
                    type="text"
                    placeholder="Search..."
                    @click.stop
                  />
                  <div
                    v-for="hopper in filteredHoppers"
                    :key="hopper.id"
                    class="dropdown-item"
                    style="cursor: pointer"
                    @click="updateSelectedHopper(hopper)"
                  >
                    {{ hopper.name }}
                  </div>
                </div>
              </div>
              <div v-if="selected_hopper">
                <h4
                  v-if="selected_recipe === null"
                  class="text-center mt-1 ms-4"
                >
                  Select Recipe
                </h4>
                <label
                  v-if="selected_recipe !== null"
                  class="mt-2 mb-2"
                >
                  Selected Recipe
                </label>
                <div
                  class="mt-2 mb-2"
                  :style="{
                    position: 'relative',
                    pointerEvents: recipes.length === 1 ? 'none' : 'auto',
                  }"
                  @click.stop="
                    recipes.length > 1 && (recipeDropdownVisible = !recipeDropdownVisible);
                    hopperDropdownVisible = false;
                  "
                >
                  <button class="form-control">
                    {{
                      selected_recipe
                        ? selected_recipe.category
                        : recipes.length > 0
                          ? "Click here to select a Recipe"
                          : "No Recipe to select"
                    }}
                  </button>
                  <div
                    v-if="recipeDropdownVisible"
                    class="dropdown-menu show w-100"
                    style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)"
                  >
                    <input
                      v-model="searchQueryRecipe"
                      class="form-control mt-1 mb-2 ms-2 w-90"
                      type="text"
                      placeholder="Search..."
                      @click.stop
                    />
                    <div
                      v-for="recipe in filteredRecipes"
                      :key="recipe.id"
                      class="dropdown-item"
                      style="cursor: pointer"
                      @click="updateSelectedRecipe(recipe)"
                    >
                      {{ recipe.category }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="selected_hopper !== null && selected_recipe !== null"
              class="card-header row"
            >
              <div>
                <div
                  class="card-body"
                  style="padding-top: 0.2rem"
                >
                  <h3 class="text-center">
                    Recipe
                    <i>{{ selected_recipe.category }}</i>
                  </h3>
                  <div class="row mt-2 mb-2">
                    <div :class="isMichiganRegionUser ? 'col-sm-12 col-md-4' : 'col-sm-6 col-md-5 col-lg-4'">
                      <label>
                        Target Throughput
                        <small
                          v-if="editedTargetThroughput || showNewPowderAmountSettings"
                          style="font-weight: lighter"
                          >(edited)</small
                        >
                      </label>
                      <input
                        v-model="target_throughput_user_input"
                        type="number"
                        class="form-control mt-2"
                        :disabled="disabled_target_throughput"
                        step="0.1"
                        min="0"
                        max="500"
                        @focus="checkLastVenturiAvailable()"
                      />
                    </div>
                    <div
                      v-if="isMichiganRegionUser"
                      class="col-sm-12 col-md-4"
                    >
                      <label>
                        Target Throughput
                        <small style="font-weight: lighter">Reduced Speed 1 </small>
                        <small
                          v-if="editedTargetThroughputReducedSpeed1 || showNewReducedSpeed1PowderAmountSettings"
                          style="font-weight: lighter"
                        >
                          (edited)</small
                        >
                      </label>
                      <input
                        v-model="target_throughput_reduced_speed_1_user_input"
                        type="number"
                        class="form-control mt-2"
                        :disabled="disabled_target_throughput"
                        step="0.1"
                        min="0"
                        max="500"
                        @focus="checkLastVenturiAvailable()"
                        @change="validateReducedSpeedThroughputs('speed1')"
                      />
                    </div>
                    <div
                      v-if="isMichiganRegionUser"
                      class="col-sm-12 col-md-4"
                    >
                      <label>
                        Target Throughput
                        <small style="font-weight: lighter">Reduced Speed 2 </small>
                        <small
                          v-if="editedTargetThroughputReducedSpeed2 || showNewReducedSpeed2PowderAmountSettings"
                          style="font-weight: lighter"
                          >(edited)</small
                        >
                      </label>
                      <input
                        v-model="target_throughput_reduced_speed_2_user_input"
                        type="number"
                        class="form-control mt-2"
                        :disabled="disabled_target_throughput"
                        step="0.1"
                        min="0"
                        max="500"
                        @focus="checkLastVenturiAvailable()"
                        @change="validateReducedSpeedThroughputs('speed2')"
                      />
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table text-center table-sm">
                      <thead>
                        <tr>
                          <th class="small">Gun Name</th>
                          <th class="small">Gun Throughput [g/min]</th>
                          <!-- <th class="small">Voltage</th> -->
                          <!-- <th class="small">Current</th> -->
                          <!-- <th class="small">AirFlow</th> -->
                          <!-- <th class="small">Gun to substrate distance</th> -->
                          <th class="small">Powder Amount</th>
                          <th class="small">
                            {{
                              showNewPowderAmountSettings
                                ? "New Powder Amount"
                                : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                            }}
                          </th>
                          <th
                            v-if="isMichiganRegionUser && selected_recipe.target_throughput_reduced_speed_1 != null"
                            class="small"
                          >
                            Powder Amount <small>(Reduced Speed 1)</small>
                          </th>
                          <th
                            v-if="isMichiganRegionUser && selected_recipe.target_throughput_reduced_speed_2 != null"
                            class="small"
                          >
                            Powder Amount <small>(Reduced Speed 2)</small>
                          </th>
                          <th class="small action-header">
                            <span>Gun Offset</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === false)"
                          :key="gun.gun_id"
                          :class="getValidationClass(gun)"
                        >
                          <td class="small">
                            {{ gun.gun_name }}
                          </td>
                          <td class="small">
                            {{
                              gun.throughput_offset != null && gun.throughput_offset != undefined
                                ? parseFloat((gun.throughput_offset * selected_recipe.target_throughput).toFixed(1))
                                : parseFloat(selected_recipe.target_throughput.toFixed(1))
                            }}
                          </td>
                          <td class="small">
                            {{
                              powder_amount_setting_by_gun_id[gun.gun_id] != null &&
                              powder_amount_setting_by_gun_id[gun.gun_id] != undefined
                                ? powder_amount_setting_by_gun_id[gun.gun_id].toFixed(1)
                                : "-"
                            }}
                          </td>
                          <td class="small">
                            <div v-if="showNewPowderAmountSettings">
                              <b>
                                {{
                                  new_powder_amount_settings_by_gun_index != null &&
                                  new_powder_amount_settings_by_gun_index[gun.gun_index] != null &&
                                  new_powder_amount_settings_by_gun_index[gun.gun_index] != undefined
                                    ? new_powder_amount_settings_by_gun_index[gun.gun_index].toFixed(1)
                                    : "-"
                                }}
                              </b>
                            </div>
                            <div v-else>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </div>
                          </td>
                          <td
                            v-if="isMichiganRegionUser && selected_recipe.target_throughput_reduced_speed_1 != null"
                            class="small"
                          >
                            <div v-if="showNewPowderAmountSettings">
                              <b>
                                {{
                                  new_powder_amount_settings_reduced_speed_1_by_gun_index != null &&
                                  new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index] != null &&
                                  new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index] != undefined
                                    ? new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index].toFixed(1)
                                    : "-"
                                }}
                              </b>
                            </div>
                            <div v-else>
                              {{
                                powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id] != null &&
                                powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id] != undefined
                                  ? powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id].toFixed(1)
                                  : "-"
                              }}
                            </div>
                          </td>
                          <td
                            v-if="isMichiganRegionUser && selected_recipe.target_throughput_reduced_speed_2 != null"
                            class="small"
                          >
                            <div v-if="showNewPowderAmountSettings">
                              <b>
                                {{
                                  new_powder_amount_settings_reduced_speed_2_by_gun_index != null &&
                                  new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index] != null &&
                                  new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index] != undefined
                                    ? new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index].toFixed(1)
                                    : "-"
                                }}
                              </b>
                            </div>
                            <div v-else>
                              {{
                                powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id] != null &&
                                powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id] != undefined
                                  ? powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id].toFixed(1)
                                  : "-"
                              }}
                            </div>
                          </td>
                          <td class="small">
                            <span>
                              <input
                                v-model="gun.display_throughput_offset"
                                class="table-input-cell"
                                type="number"
                              />
                              %
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-if="coating_booth.reciprocator_side_bottom">
                    <div class="row mt-2 mb-2">
                      <div :class="isMichiganRegionUser ? 'col-sm-12 col-md-4' : 'col-sm-6 col-md-5 col-lg-4'">
                        <label>
                          Target Throughput Bottom
                          <small
                            v-if="editedTargetThroughputBottom || showNewPowderAmountSettings"
                            style="font-weight: lighter"
                            >(edited)</small
                          >
                        </label>
                        <input
                          v-model="target_throughput_bottom_user_input"
                          type="number"
                          class="form-control mt-2"
                          :disabled="disabled_target_throughput"
                          :step="0.1"
                          @focus="checkLastVenturiAvailable()"
                        />
                      </div>
                      <div
                        v-if="isMichiganRegionUser"
                        class="col-sm-12 col-md-4"
                      >
                        <label>
                          Target Throughput Bottom
                          <small style="font-weight: lighter">Reduced Speed 1 </small>
                          <small
                            v-if="
                              editedTargetThroughputBottomReducedSpeed1 ||
                              showNewBottomReducedSpeed1PowderAmountSettings
                            "
                            style="font-weight: lighter"
                            >(edited)</small
                          >
                        </label>
                        <input
                          v-model="target_throughput_bottom_reduced_speed_1_user_input"
                          type="number"
                          class="form-control mt-2"
                          :disabled="disabled_target_throughput"
                          step="0.1"
                          min="0"
                          max="500"
                          @focus="checkLastVenturiAvailable()"
                          @change="validateBottomReducedSpeedThroughputs('speed1')"
                        />
                      </div>
                      <div
                        v-if="isMichiganRegionUser"
                        class="col-sm-12 col-md-4"
                      >
                        <label>
                          Target Throughput Bottom
                          <small style="font-weight: lighter">Reduced Speed 2 </small>
                          <small
                            v-if="
                              editedTargetThroughputBottomReducedSpeed2 ||
                              showNewBottomReducedSpeed2PowderAmountSettings
                            "
                            style="font-weight: lighter"
                            >(edited)</small
                          >
                        </label>
                        <input
                          v-model="target_throughput_bottom_reduced_speed_2_user_input"
                          type="number"
                          class="form-control mt-2"
                          :disabled="disabled_target_throughput"
                          step="0.1"
                          min="0"
                          max="500"
                          @focus="checkLastVenturiAvailable()"
                          @change="validateBottomReducedSpeedThroughputs('speed2')"
                        />
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table text-center table-sm">
                        <thead>
                          <tr>
                            <th class="small">Gun Name</th>
                            <th class="small">Gun Throughput [g/min]</th>
                            <!-- <th class="small">Voltage</th> -->
                            <!-- <th class="small">Current</th> -->
                            <!-- <th class="small">AirFlow</th> -->
                            <!-- <th class="small">Gun to substrate distance</th> -->
                            <th class="small">Powder Amount</th>
                            <th class="small">
                              {{
                                showNewPowderAmountSettings
                                  ? "New Powder Amount"
                                  : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                              }}
                            </th>
                            <th
                              v-if="
                                isMichiganRegionUser && selected_recipe.target_throughput_bottom_reduced_speed_1 != null
                              "
                              class="small"
                            >
                              Powder Amount <small>(Reduced Speed 1)</small>
                            </th>
                            <th
                              v-if="
                                isMichiganRegionUser && selected_recipe.target_throughput_bottom_reduced_speed_2 != null
                              "
                              class="small"
                            >
                              Powder Amount <small>(Reduced Speed 2)</small>
                            </th>
                            <th class="small action-header">
                              <span>Gun Offset</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="gun in gun_data.filter(gun => gun.is_gun_on_bottom_reciprocator === true)"
                            :key="gun.gun_id"
                            :class="getValidationClass(gun)"
                          >
                            <td class="small">
                              {{ gun.gun_name }}
                            </td>
                            <td class="small">
                              {{
                                gun.throughput_offset != null && gun.throughput_offset != undefined
                                  ? parseFloat(
                                      (gun.throughput_offset * selected_recipe.target_throughput_bottom).toFixed(1),
                                    )
                                  : parseFloat(selected_recipe.target_throughput_bottom.toFixed(1))
                              }}
                            </td>
                            <td class="small">
                              {{
                                powder_amount_setting_by_gun_id[gun.gun_id] != null &&
                                powder_amount_setting_by_gun_id[gun.gun_id] != undefined
                                  ? powder_amount_setting_by_gun_id[gun.gun_id].toFixed(1)
                                  : "-"
                              }}
                            </td>
                            <td class="small">
                              <div v-if="showNewPowderAmountSettings">
                                <b>
                                  {{
                                    new_powder_amount_settings_by_gun_index != null &&
                                    new_powder_amount_settings_by_gun_index[gun.gun_index] != null &&
                                    new_powder_amount_settings_by_gun_index[gun.gun_index] != undefined
                                      ? new_powder_amount_settings_by_gun_index[gun.gun_index].toFixed(1)
                                      : "-"
                                  }}
                                </b>
                              </div>
                              <div v-else>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              </div>
                            </td>
                            <td
                              v-if="
                                isMichiganRegionUser && selected_recipe.target_throughput_bottom_reduced_speed_1 != null
                              "
                              class="small"
                            >
                              <div v-if="showNewPowderAmountSettings">
                                <b>
                                  {{
                                    new_powder_amount_settings_reduced_speed_1_by_gun_index != null &&
                                    new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index] != null &&
                                    new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index] != undefined
                                      ? new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index].toFixed(
                                          1,
                                        )
                                      : "-"
                                  }}
                                </b>
                              </div>
                              <div v-else>
                                {{
                                  powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id] != null &&
                                  powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id] != undefined
                                    ? powder_amount_setting_reduced_speed_1_by_gun_id[gun.gun_id].toFixed(1)
                                    : "-"
                                }}
                              </div>
                            </td>
                            <td
                              v-if="
                                isMichiganRegionUser && selected_recipe.target_throughput_bottom_reduced_speed_2 != null
                              "
                              class="small"
                            >
                              <div v-if="showNewPowderAmountSettings">
                                <b>
                                  {{
                                    new_powder_amount_settings_reduced_speed_2_by_gun_index != null &&
                                    new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index] != null &&
                                    new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index] != undefined
                                      ? new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index].toFixed(
                                          1,
                                        )
                                      : "-"
                                  }}
                                </b>
                              </div>
                              <div v-else>
                                {{
                                  powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id] != null &&
                                  powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id] != undefined
                                    ? powder_amount_setting_reduced_speed_2_by_gun_id[gun.gun_id].toFixed(1)
                                    : "-"
                                }}
                              </div>
                            </td>
                            <td class="small">
                              <span>
                                <input
                                  v-model="gun.display_throughput_offset"
                                  class="table-input-cell"
                                  type="number"
                                />
                                %
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="color-legend mb-3">
                    <div class="legend-item">
                      <span class="color-box valid-row"></span>
                      <span>Valid</span>
                    </div>
                    <div class="legend-item">
                      <span class="color-box accepted-row"></span>
                      <span>Change Venturi</span>
                    </div>
                    <div class="legend-item">
                      <span class="color-box rejected-row"></span>
                      <span>Service</span>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-12 text-center">
                    <soft-button
                      type="button"
                      :color="isComputeButtonEnabled ? 'success' : 'secondary'"
                      :variant="isComputeButtonEnabled ? 'gradient' : 'outline'"
                      :disabled="!isComputeButtonEnabled"
                      class="mt-2 w-100"
                      @click="handleComputeButtonClick()"
                    >
                      {{ isComputeButtonEnabled ? "Compute new Powder Amount Settings" : "Edit Target Throughput" }}
                    </soft-button>
                  </div>
                  <div class="d-flex flex-row mt-4">
                    <soft-button
                      type="button"
                      color="secondary"
                      variant="gradient"
                      class="mb-0 me-2 js-btn-next"
                      style="min-width: 130px; max-width: 500px"
                      @click="
                        $router.push({
                          name: 'SteelCaseDashboard',
                          params: {
                            lineId: coating_booth.id,
                          },
                        })
                      "
                    >
                      Go Back &nbsp; &nbsp;
                    </soft-button>
                    <soft-button
                      type="button"
                      color="warning"
                      variant="gradient"
                      class="mb-0 me-2"
                      style="min-width: 130px; max-width: 500px"
                      @click="resetRecipeSettings()"
                    >
                      Reset Recipe
                    </soft-button>
                    <soft-button
                      type="button"
                      :color="showNewPowderAmountSettings ? 'primary' : 'secondary'"
                      :variant="showNewPowderAmountSettings ? 'gradient' : 'outline'"
                      :disabled="!showNewPowderAmountSettings"
                      class="mb-0 w-100"
                      style="min-width: 200px"
                      @click="updateRecipeSettings()"
                    >
                      {{
                        !isComputeButtonEnabled && !newPowderAmountSettings
                          ? "Edit Target Throughput to save changes"
                          : showNewPowderAmountSettings
                            ? "Save Target Throughput & Powder Amount Settings"
                            : "Compute new Powder Amount settings to save changes"
                      }}
                    </soft-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import {
  autoFillInputColumn,
  getCombinedGunNames,
  numericPositiveOnly,
  roundPowderAmountParameters,
} from "@/views/composables.js";
import SoftButton from "@/components/SoftButton.vue";

export default {
  name: "ViewRecipes",
  components: {
    SoftButton,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      coating_booth: {},
      hoppers: [],
      selected_hopper: null,
      selected_recipe: null,
      new_powder_amount_settings_by_gun_index: null,
      new_powder_amount_settings_reduced_speed_1_by_gun_index: null,
      new_powder_amount_settings_reduced_speed_2_by_gun_index: null,
      hopperDropdownVisible: false,
      recipeDropdownVisible: false,
      searchQueryHopper: "",
      searchQueryRecipe: "",
      min_powder_amount_setting: null,
      max_powder_amount_setting: null,
      target_throughput_user_input: null,
      disabled_target_throughput: false,
      target_throughput_bottom_user_input: null,
      target_throughput_reduced_speed_1_user_input: null,
      target_throughput_reduced_speed_2_user_input: null,
      target_throughput_bottom_reduced_speed_1_user_input: null,
      target_throughput_bottom_reduced_speed_2_user_input: null,
      powder_amount_setting_by_gun_id: {},
      powder_amount_setting_reduced_speed_1_by_gun_id: {},
      powder_amount_setting_reduced_speed_2_by_gun_id: {},
      gun_names: [],
      gun_data: [],
      gun_output_data: {},
      recipes: [],
      current_real_powder_throughput: [],
      current_is_compliant: [],
    };
  },
  computed: {
    editedTargetThroughput() {
      if (this.target_throughput_user_input == null) {
        return false;
      }
      return (
        Number(this.selected_recipe.target_throughput).toFixed(1) !==
        Number(this.target_throughput_user_input).toFixed(1)
      );
    },
    editedTargetThroughputBottom() {
      if (this.target_throughput_bottom_user_input == null || this.selected_recipe.target_throughput_bottom == null) {
        return false;
      }
      return (
        Number(this.selected_recipe.target_throughput_bottom).toFixed(1) !==
        Number(this.target_throughput_bottom_user_input).toFixed(1)
      );
    },
    editedTargetThroughputReducedSpeed1() {
      if (
        this.target_throughput_reduced_speed_1_user_input == null ||
        this.target_throughput_reduced_speed_1_user_input === ""
      ) {
        return this.selected_recipe.target_throughput_reduced_speed_1 != null;
      }
      if (this.selected_recipe.target_throughput_reduced_speed_1 == null) {
        return true;
      }
      return (
        Number(this.selected_recipe.target_throughput_reduced_speed_1).toFixed(1) !==
        Number(this.target_throughput_reduced_speed_1_user_input).toFixed(1)
      );
    },
    editedTargetThroughputReducedSpeed2() {
      if (
        this.target_throughput_reduced_speed_2_user_input == null ||
        this.target_throughput_reduced_speed_2_user_input === ""
      ) {
        return this.selected_recipe.target_throughput_reduced_speed_2 != null;
      }
      if (this.selected_recipe.target_throughput_reduced_speed_2 == null) {
        return true;
      }
      return (
        Number(this.selected_recipe.target_throughput_reduced_speed_2).toFixed(1) !==
        Number(this.target_throughput_reduced_speed_2_user_input).toFixed(1)
      );
    },
    editedTargetThroughputBottomReducedSpeed1() {
      if (
        this.target_throughput_bottom_reduced_speed_1_user_input == null ||
        this.target_throughput_bottom_reduced_speed_1_user_input === ""
      ) {
        return this.selected_recipe.target_throughput_bottom_reduced_speed_1 != null;
      }
      if (this.selected_recipe.target_throughput_bottom_reduced_speed_1 == null) {
        return true;
      }
      return (
        Number(this.selected_recipe.target_throughput_bottom_reduced_speed_1).toFixed(1) !==
        Number(this.target_throughput_bottom_reduced_speed_1_user_input).toFixed(1)
      );
    },
    editedTargetThroughputBottomReducedSpeed2() {
      if (
        this.target_throughput_bottom_reduced_speed_2_user_input == null ||
        this.target_throughput_bottom_reduced_speed_2_user_input === ""
      ) {
        return this.selected_recipe.target_throughput_bottom_reduced_speed_2 != null;
      }
      if (this.selected_recipe.target_throughput_bottom_reduced_speed_2 == null) {
        return true;
      }
      return (
        Number(this.selected_recipe.target_throughput_bottom_reduced_speed_2).toFixed(1) !==
        Number(this.target_throughput_bottom_reduced_speed_2_user_input).toFixed(1)
      );
    },
    validTargetThroughputUserInputs() {
      if (this.coating_booth.reciprocator_side_bottom) {
        return this.target_throughput_user_input > 0 && this.target_throughput_bottom_user_input > 0;
      } else {
        return this.target_throughput_user_input > 0;
      }
    },
    newPowderAmountSettings() {
      return (
        this.selected_hopper != null &&
        this.selected_recipe != null &&
        this.new_powder_amount_settings_by_gun_index != null
      );
    },
    showNewPowderAmountSettings() {
      return (
        this.newPowderAmountSettings &&
        !this.editedTargetThroughput &&
        !this.editedThroughputOffsets &&
        !this.editedTargetThroughputBottom &&
        !this.editedTargetThroughputReducedSpeed1 &&
        !this.editedTargetThroughputReducedSpeed2 &&
        !this.editedTargetThroughputBottomReducedSpeed1 &&
        !this.editedTargetThroughputBottomReducedSpeed2
      );
    },
    showNewReducedSpeed1PowderAmountSettings() {
      return (
        this.showNewPowderAmountSettings &&
        this.new_powder_amount_settings_reduced_speed_1_by_gun_index != null &&
        Object.keys(this.new_powder_amount_settings_reduced_speed_1_by_gun_index).length > 0
      );
    },
    showNewReducedSpeed2PowderAmountSettings() {
      return (
        this.showNewPowderAmountSettings &&
        this.new_powder_amount_settings_reduced_speed_2_by_gun_index != null &&
        Object.keys(this.new_powder_amount_settings_reduced_speed_2_by_gun_index).length > 0
      );
    },
    showNewBottomReducedSpeed1PowderAmountSettings() {
      return (
        this.showNewPowderAmountSettings &&
        this.new_powder_amount_settings_reduced_speed_1_by_gun_index != null &&
        this.gun_data
          .filter(gun => gun.is_gun_on_bottom_reciprocator === true)
          .some(gun => this.new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index] != null)
      );
    },
    showNewBottomReducedSpeed2PowderAmountSettings() {
      return (
        this.showNewPowderAmountSettings &&
        this.new_powder_amount_settings_reduced_speed_2_by_gun_index != null &&
        this.gun_data
          .filter(gun => gun.is_gun_on_bottom_reciprocator === true)
          .some(gun => this.new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index] != null)
      );
    },
    filteredHoppers() {
      return this.hoppers.filter(hopper => hopper.name.toLowerCase().includes(this.searchQueryHopper.toLowerCase()));
    },
    filteredRecipes() {
      return this.recipes.filter(recipe =>
        recipe.category.toLowerCase().includes(this.searchQueryRecipe.toLowerCase()),
      );
    },
    editedThroughputOffsets() {
      return this.gun_data.some(gun => this.isOffsetDataChanged(gun));
    },
    isComputeButtonEnabled() {
      return (
        (this.isMichiganRegionUser ||
          this.editedThroughputOffsets ||
          this.editedTargetThroughput ||
          this.editedTargetThroughputBottom ||
          this.editedTargetThroughputReducedSpeed1 ||
          this.editedTargetThroughputReducedSpeed2 ||
          this.editedTargetThroughputBottomReducedSpeed1 ||
          this.editedTargetThroughputBottomReducedSpeed2) &&
        this.validTargetThroughputUserInputs
      );
    },
    isMichiganRegionUser() {
      return this.$store.state.user_data.steelcase_service_region === "MICHIGAN";
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    document.addEventListener("click", this.closeDropdown);
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    autoFillInputColumn,
    numericPositiveOnly,
    getCombinedGunNames,
    roundPowderAmountParameters,
    async getData() {
      await this.getCoatingBooth();
      this.gun_data = await this.getGunData();
      await this.getHoppers();

      // Auto-select hopper and recipe from query string if present
      if (this.$route.query.hopper && this.selected_hopper == null) {
        const queryHopper = this.hoppers.find(hopper => hopper.id == this.$route.query.hopper);
        if (queryHopper) {
          await this.updateSelectedHopper(queryHopper);
        }
      }

      if (this.selected_hopper != null) {
        await this.getRecipes();
        if (this.$route.query.recipe && this.selected_recipe == null) {
          const queryRecipe = this.recipes.find(recipe => recipe.id == this.$route.query.recipe);
          if (queryRecipe) {
            await this.updateSelectedRecipe(queryRecipe);
          }
        }
      }
    },
    async getCoatingBooth() {
      try {
        const response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async updateSelectedHopper(hopper) {
      this.searchQueryHopper = "";
      if (this.selected_hopper != hopper) {
        this.clearGunData();
        this.disabled_target_throughput = false;
        this.selected_recipe = null;
        this.target_throughput_user_input = null;
        this.target_throughput_reduced_speed_1_user_input = null;
        this.target_throughput_reduced_speed_2_user_input = null;
        this.target_throughput_bottom_reduced_speed_1_user_input = null;
        this.target_throughput_bottom_reduced_speed_2_user_input = null;
        this.selected_hopper = hopper;
        // Update query string with selected hopper
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, hopper: hopper.id },
        });
        await this.getRecipes();
      }
    },
    async updateSelectedRecipe(recipe) {
      this.$store.state.isLoading = true;
      this.searchQueryRecipe = "";
      this.disabled_target_throughput = false;
      this.selected_recipe = recipe;
      this.target_throughput_user_input = recipe.target_throughput.toFixed(1);
      this.target_throughput_bottom_user_input = recipe.target_throughput_bottom
        ? recipe.target_throughput_bottom.toFixed(1)
        : null;
      this.target_throughput_reduced_speed_1_user_input = recipe.target_throughput_reduced_speed_1
        ? recipe.target_throughput_reduced_speed_1.toFixed(1)
        : null;
      this.target_throughput_reduced_speed_2_user_input = recipe.target_throughput_reduced_speed_2
        ? recipe.target_throughput_reduced_speed_2.toFixed(1)
        : null;
      this.target_throughput_bottom_reduced_speed_1_user_input = recipe.target_throughput_bottom_reduced_speed_1
        ? recipe.target_throughput_bottom_reduced_speed_1.toFixed(1)
        : null;
      this.target_throughput_bottom_reduced_speed_2_user_input = recipe.target_throughput_bottom_reduced_speed_2
        ? recipe.target_throughput_bottom_reduced_speed_2.toFixed(1)
        : null;
      this.new_powder_amount_settings_by_gun_index = null;
      this.new_powder_amount_settings_reduced_speed_1_by_gun_index = null;
      this.new_powder_amount_settings_reduced_speed_2_by_gun_index = null;
      this.clearGunData();
      this.updatePowderAmountSettingByGunId();
      // Update query string with selected recipe
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, recipe: recipe.id },
      });
      await this.getGunStatusByRecipe();
      await Promise.all([this.getLastVenturiDiameters(), this.getThroughputOffsets()]);
      this.$store.state.isLoading = false;
    },
    updatePowderAmountSettingByGunId() {
      this.powder_amount_setting_by_gun_id = {};
      if (this.selected_recipe.latest_powder_amount_settings) {
        this.selected_recipe.latest_powder_amount_settings.forEach(powder_amount_setting => {
          this.powder_amount_setting_by_gun_id[powder_amount_setting.gun] = powder_amount_setting.amount;
        });
      }
      this.powder_amount_setting_reduced_speed_1_by_gun_id = {};
      if (this.selected_recipe.latest_powder_amount_settings_reduced_speed_1) {
        this.selected_recipe.latest_powder_amount_settings_reduced_speed_1.forEach(pas => {
          this.powder_amount_setting_reduced_speed_1_by_gun_id[pas.gun] = pas.amount;
        });
      }
      this.powder_amount_setting_reduced_speed_2_by_gun_id = {};
      if (this.selected_recipe.latest_powder_amount_settings_reduced_speed_2) {
        this.selected_recipe.latest_powder_amount_settings_reduced_speed_2.forEach(pas => {
          this.powder_amount_setting_reduced_speed_2_by_gun_id[pas.gun] = pas.amount;
        });
      }
    },
    async getGunStatusByRecipe() {
      try {
        let gun_diagnosis_response = await axios.get(
          `api/v1/steelcase/getlastguninferredstatusforrecipe/coating-booth/${this.coating_booth.id}/recipe/${this.selected_recipe.id}/`,
        );
        const diagnosis_by_gun_id = gun_diagnosis_response.data.diagnosis_by_gun_id;
        this.gun_data = this.gun_data.map(gun => {
          return {
            ...gun,
            diagnosis: diagnosis_by_gun_id[gun.gun_id],
          };
        });
      } catch (error) {
        if (error.response.status == 404) {
          await this.$swal({
            title: "No Gun Status Data",
            text: `This Recipe has no previous gun status data. Perform the initial bagging or modify throughput and recalculate powder amount setting to visualize a gun status.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
      return null;
    },
    async getThroughputOffsets() {
      try {
        const response = await axios.get(
          "/api/v1/steelcase/target-throughput-offset?recipe_id=" + this.selected_recipe.id,
        );
        const gunOffsets = response.data;
        for (const gun of this.gun_data) {
          const throughputOffset = gunOffsets.find(o => o.gun === gun.gun_id);
          if (throughputOffset) {
            gun.throughput_offset = throughputOffset.offset;
            gun.display_throughput_offset = ((gun.throughput_offset - 1) * 100).toFixed(0);
          } else {
            // default value if no offset is in the db
            gun.throughput_offset = 1;
            gun.display_throughput_offset = "0";
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async handleComputeButtonClick() {
      this.$store.state.isLoading = true;
      try {
        if (this.editedThroughputOffsets) {
          this.gun_data.forEach(async gun => {
            gun.throughput_offset = 1 + parseFloat(gun.display_throughput_offset) / 100;
          });
          await this.updateThroughputOffsets();
        }
        await this.computeNewPowderAmountSettings();
      } catch (error) {
        console.error(error);
      }
      this.$store.state.isLoading = false;
    },
    async updateThroughputOffsets() {
      const offsetsByGunIdData = {};
      this.gun_data.forEach(gun => {
        offsetsByGunIdData[gun.gun_id] = gun.throughput_offset;
      });

      await axios.post("api/v1/steelcase/target-throughput-offset/bulk-create-update/ ", {
        recipe_id: this.selected_recipe.id,
        offsets_by_gun_id: offsetsByGunIdData,
      });
    },
    isOffsetDataChanged(gun) {
      if (gun.display_throughput_offset != ((gun.throughput_offset - 1) * 100).toFixed(0)) {
        return true;
      }
      return false;
    },
    clearGunData() {
      this.gun_data = this.gun_data.map(gun => ({
        ...gun,
        diagnosis: null,
        real_throughput: null,
        throughput_offset: null,
        display_throughput_offset: null,
      }));
    },
    mapInferenceData(received_data) {
      const updated_guns_array = this.gun_data.map(gun => {
        const received_diagnosis = received_data[gun.gun_index].diagnosis;
        const received_real_throughput = received_data[gun.gun_index].real_throughput;
        return {
          ...gun,
          diagnosis: received_diagnosis,
          real_throughput: received_real_throughput,
        };
      });
      this.gun_data = updated_guns_array;
    },
    async computeNewPowderAmountSettings() {
      this.$store.state.isLoading = true;
      try {
        const reducedSpeed1 =
          this.target_throughput_reduced_speed_1_user_input === ""
            ? null
            : this.target_throughput_reduced_speed_1_user_input;
        const reducedSpeed2 =
          this.target_throughput_reduced_speed_2_user_input === ""
            ? null
            : this.target_throughput_reduced_speed_2_user_input;
        const bottomReducedSpeed1 =
          this.target_throughput_bottom_reduced_speed_1_user_input === ""
            ? null
            : this.target_throughput_bottom_reduced_speed_1_user_input;
        const bottomReducedSpeed2 =
          this.target_throughput_bottom_reduced_speed_2_user_input === ""
            ? null
            : this.target_throughput_bottom_reduced_speed_2_user_input;
        const response = await axios.post("api/v1/steelcase/computerecipepowderamountsettingsfromtargetthroughput/", {
          recipe_id: this.selected_recipe.id,
          target_throughput: this.target_throughput_user_input,
          target_throughput_bottom: this.target_throughput_bottom_user_input,
          target_throughput_reduced_speed_1: reducedSpeed1,
          target_throughput_reduced_speed_2: reducedSpeed2,
          target_throughput_bottom_reduced_speed_1: bottomReducedSpeed1,
          target_throughput_bottom_reduced_speed_2: bottomReducedSpeed2,
        });
        const powder_amount_settings_by_gun_index = response.data.powder_amount_settings_by_gun_index;

        this.gun_output_data = response.data.gun_output_data;
        this.selected_recipe.target_throughput = this.target_throughput_user_input;
        this.selected_recipe.target_throughput_bottom = this.target_throughput_bottom_user_input;
        this.selected_recipe.target_throughput_reduced_speed_1 = reducedSpeed1;
        this.selected_recipe.target_throughput_reduced_speed_2 = reducedSpeed2;
        this.selected_recipe.target_throughput_bottom_reduced_speed_1 = bottomReducedSpeed1;
        this.selected_recipe.target_throughput_bottom_reduced_speed_2 = bottomReducedSpeed2;
        this.new_powder_amount_settings_by_gun_index = {};
        this.new_powder_amount_settings_reduced_speed_1_by_gun_index = {};
        this.new_powder_amount_settings_reduced_speed_2_by_gun_index = {};
        this.powder_amount_setting_reduced_speed_1_by_gun_id = {};
        this.powder_amount_setting_reduced_speed_2_by_gun_id = {};
        Object.entries(powder_amount_settings_by_gun_index).forEach(([gun_index, setting]) => {
          this.new_powder_amount_settings_by_gun_index[gun_index] = setting.new_powder_amount_setting;
          if (setting.new_powder_amount_setting_reduced_speed_1 != null) {
            this.new_powder_amount_settings_reduced_speed_1_by_gun_index[gun_index] =
              setting.new_powder_amount_setting_reduced_speed_1;
          }
          if (setting.new_powder_amount_setting_reduced_speed_2 != null) {
            this.new_powder_amount_settings_reduced_speed_2_by_gun_index[gun_index] =
              setting.new_powder_amount_setting_reduced_speed_2;
          }
        });
        this.mapInferenceData(powder_amount_settings_by_gun_index);
        this.$store.state.isLoading = false;
      } catch (error) {
        this.$store.state.isLoading = false;
        console.error(error);
        await this.$swal({
          title: "Error",
          text: `An error occurred while computing new Powder Amount settings. You may need to check the given recipe settings or redo bagging process to retrain our system.`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
      return;
    },
    async getRecipes() {
      try {
        let response = await axios.get("api/v1/steelcase/recipe/hopper/" + this.selected_hopper.id + "/");
        this.recipes = response.data.filter(recipe => recipe.active);

        if (this.recipes.length === 1) {
          await this.updateSelectedRecipe(this.recipes[0]);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getHoppers() {
      if (this.coating_booth.id === null) {
        return;
      }
      try {
        let response = await axios.get("api/v1/steelcase/hopper/coating-booth/" + this.coating_booth.id + "/");
        this.hoppers = response.data;

        if (this.hoppers.length === 1) {
          this.selected_hopper = this.hoppers[0];
        }
      } catch (error) {
        console.error(error);
      }
    },
    getValidationClass(gun) {
      if (!gun.diagnosis) {
        return "";
      }
      switch (gun.diagnosis) {
        case "success":
          return "valid-row";
        case "change venturi diameter":
          return "accepted-row";
        case "failure":
          return "rejected-row";
        default:
          return "";
      }
    },
    enrichGunData(gunData) {
      const gun = { ...gunData };
      gun.gun_id = gunData.id;

      gun.gun_name = gunData.name;
      gun.diagnosis = null;
      gun.real_throughput = null;
      gun.recipes = null;
      gun.throughput_offset = null;
      gun.display_throughput_offset = null;

      return gun;
    },
    async getGunData() {
      try {
        const guns = (await axios.get("api/v1/steelcase/guns/coating-booth/" + this.coating_booth.id + "/")).data;
        const enriched_guns = guns.map(gun => this.enrichGunData(gun));
        return enriched_guns.sort((a, b) => a.gun_index - b.gun_index);
      } catch (error) {
        console.error(error);
      }
    },
    async updateRecipeSettings() {
      if (this.selected_hopper == null || this.selected_recipe == null) {
        return;
      }

      try {
        const powder_amount_settings_per_gun = this.gun_data
          .map(gun => ({
            gun_id: gun.gun_id,
            powder_amount_setting: this.new_powder_amount_settings_by_gun_index[gun.gun_index],
          }))
          .filter(gun => gun.powder_amount_setting !== null && gun.powder_amount_setting !== undefined);

        const powder_amount_settings_reduced_speed_1_per_gun = this
          .new_powder_amount_settings_reduced_speed_1_by_gun_index
          ? this.gun_data
              .map(gun => ({
                gun_id: gun.gun_id,
                powder_amount_setting: this.new_powder_amount_settings_reduced_speed_1_by_gun_index[gun.gun_index],
              }))
              .filter(gun => gun.powder_amount_setting !== null && gun.powder_amount_setting !== undefined)
          : null;

        const powder_amount_settings_reduced_speed_2_per_gun = this
          .new_powder_amount_settings_reduced_speed_2_by_gun_index
          ? this.gun_data
              .map(gun => ({
                gun_id: gun.gun_id,
                powder_amount_setting: this.new_powder_amount_settings_reduced_speed_2_by_gun_index[gun.gun_index],
              }))
              .filter(gun => gun.powder_amount_setting !== null && gun.powder_amount_setting !== undefined)
          : null;

        try {
          const createPayload = {
            recipe_id: this.selected_recipe.id,
            powder_amount_settings_per_gun: powder_amount_settings_per_gun,
          };
          if (
            powder_amount_settings_reduced_speed_1_per_gun &&
            powder_amount_settings_reduced_speed_1_per_gun.length > 0
          ) {
            createPayload.powder_amount_settings_reduced_speed_1_per_gun =
              powder_amount_settings_reduced_speed_1_per_gun;
          }
          if (
            powder_amount_settings_reduced_speed_2_per_gun &&
            powder_amount_settings_reduced_speed_2_per_gun.length > 0
          ) {
            createPayload.powder_amount_settings_reduced_speed_2_per_gun =
              powder_amount_settings_reduced_speed_2_per_gun;
          }
          await axios.post("api/v1/steelcase/createpowderamountsettingsbyrecipe/", createPayload);
        } catch (error) {
          console.error(error);
          await this.$swal({
            title: "Error",
            text: "An error occurred while saving Powder Amount settings.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }

        await this.storeInferredGunCoefficientsAndStatus();
        const recipePatchData = {
          target_throughput: this.target_throughput_user_input,
          target_throughput_bottom: this.target_throughput_bottom_user_input,
          target_throughput_reduced_speed_1:
            this.target_throughput_reduced_speed_1_user_input != null &&
            this.target_throughput_reduced_speed_1_user_input !== ""
              ? this.target_throughput_reduced_speed_1_user_input
              : null,
          target_throughput_reduced_speed_2:
            this.target_throughput_reduced_speed_2_user_input != null &&
            this.target_throughput_reduced_speed_2_user_input !== ""
              ? this.target_throughput_reduced_speed_2_user_input
              : null,
          target_throughput_bottom_reduced_speed_1:
            this.target_throughput_bottom_reduced_speed_1_user_input != null &&
            this.target_throughput_bottom_reduced_speed_1_user_input !== ""
              ? this.target_throughput_bottom_reduced_speed_1_user_input
              : null,
          target_throughput_bottom_reduced_speed_2:
            this.target_throughput_bottom_reduced_speed_2_user_input != null &&
            this.target_throughput_bottom_reduced_speed_2_user_input !== ""
              ? this.target_throughput_bottom_reduced_speed_2_user_input
              : null,
        };
        await axios.patch("api/v1/steelcase/recipe/" + this.selected_recipe.id + "/", recipePatchData);

        await this.$swal({
          title: "Recipe updated",
          text: `Recipe updated with new Powder Throughput and new Powder Amount settings.`,
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success w-40 px-1 m-2",
          },
          buttonsStyling: false,
        });

        await this.getRecipes();
        await this.updateSelectedRecipe(this.recipes.find(recipe => recipe.id === this.selected_recipe.id));
      } catch (error) {
        console.error(error);
      }
    },
    async storeInferredGunCoefficientsAndStatus() {
      const hopper_id = this.selected_hopper.id;
      const recipe_id = this.selected_recipe.id;
      const diagnosis_per_recipe = [recipe_id].reduce((recipe_dict, recipe_id) => {
        recipe_dict[recipe_id] = this.gun_data.reduce((gun_dict, gun) => {
          gun_dict[gun.gun_identifier] = gun.diagnosis;
          return gun_dict;
        }, {});
        return recipe_dict;
      }, {});

      await axios.post("api/v1/steelcase/bulkupdateinferredcoefficientsandstatus/", {
        hopper_id: hopper_id,
        gun_output_data: this.gun_output_data,
        diagnosis_per_recipe: diagnosis_per_recipe,
      });
    },
    async getLastVenturiDiameters() {
      try {
        const response = await axios.get(`api/v1/steelcase/getlatestventuridiameters/${this.selected_hopper.id}/`);

        if (response.data.venturi_diameters_by_gun_id) {
          this.gun_data = this.gun_data.map(gun => {
            const diameter = response.data.venturi_diameters_by_gun_id[gun.gun_id];
            return diameter ? { ...gun, diameter: diameter } : gun;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    resetRecipeSettings() {
      if (this.selected_recipe == null || this.selected_hopper == null) {
        return;
      }
      this.$router.push({
        name: "ResetRecipe",
        params: {
          lineId: this.coating_booth.id,
          hopperId: this.selected_hopper.id,
          recipeId: this.selected_recipe.id,
        },
      });
    },
    checkLastVenturiAvailable() {
      if (
        !this.disabled_target_throughput &&
        this.gun_data.every(gun => gun.diameter === undefined || gun.diameter === null || gun.diameter === "")
      ) {
        this.$swal({
          title: "Recipe is not editable",
          text: `Target Throughput is not editable, because the venturi diameters are not known for this Hopper. Please perform a Bagging or Measure diameters process.`,
          icon: "error",
          cancelButtonText: "Cancel",
          confirmButtonText: `OK, go to Line`,
          customClass: {
            confirmButton: "btn bg-gradient-success w-40",
            cancelButton: "btn bg-gradient-danger w-40",
          },
          reverseButtons: true,
          buttonsStyling: false,
          showCancelButton: true,
        }).then(result => {
          this.disabled_target_throughput = true;
          if (result.isConfirmed) {
            this.$router.push({
              name: "SteelCaseDashboard",
              params: { lineId: this.coating_booth.id },
            });
          }
        });
      }
    },
    validateReducedSpeedThroughputs(changedField) {
      if (
        this.target_throughput_reduced_speed_1_user_input === "" ||
        this.target_throughput_reduced_speed_1_user_input === undefined ||
        this.target_throughput_reduced_speed_1_user_input === 0
      ) {
        this.target_throughput_reduced_speed_1_user_input = null;
      }
      if (
        this.target_throughput_reduced_speed_2_user_input === "" ||
        this.target_throughput_reduced_speed_2_user_input === undefined ||
        this.target_throughput_reduced_speed_2_user_input === 0
      ) {
        this.target_throughput_reduced_speed_2_user_input = null;
      }
      const speed1 = parseFloat(this.target_throughput_reduced_speed_1_user_input);
      const speed2 = parseFloat(this.target_throughput_reduced_speed_2_user_input);
      if (isNaN(speed1) || isNaN(speed2)) return;

      if (speed2 >= speed1) {
        this.$swal({
          title: "Invalid Throughput Values",
          text: "Target Throughput Reduced Speed 2 must be smaller than Target Throughput Reduced Speed 1.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        if (changedField === "speed2") {
          this.target_throughput_reduced_speed_2_user_input = null;
        } else {
          this.target_throughput_reduced_speed_1_user_input = null;
        }
      }
    },
    validateBottomReducedSpeedThroughputs(changedField) {
      if (
        this.target_throughput_bottom_reduced_speed_1_user_input === "" ||
        this.target_throughput_bottom_reduced_speed_1_user_input === undefined ||
        this.target_throughput_bottom_reduced_speed_1_user_input === 0
      ) {
        this.target_throughput_bottom_reduced_speed_1_user_input = null;
      }
      if (
        this.target_throughput_bottom_reduced_speed_2_user_input === "" ||
        this.target_throughput_bottom_reduced_speed_2_user_input === undefined ||
        this.target_throughput_bottom_reduced_speed_2_user_input === 0
      ) {
        this.target_throughput_bottom_reduced_speed_2_user_input = null;
      }
      const speed1 = parseFloat(this.target_throughput_bottom_reduced_speed_1_user_input);
      const speed2 = parseFloat(this.target_throughput_bottom_reduced_speed_2_user_input);
      if (isNaN(speed1) || isNaN(speed2)) return;

      if (speed2 >= speed1) {
        this.$swal({
          title: "Invalid Throughput Values",
          text: "Target Throughput Bottom Reduced Speed 2 must be smaller than Target Throughput Bottom Reduced Speed 1.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        if (changedField === "speed2") {
          this.target_throughput_bottom_reduced_speed_2_user_input = null;
        } else {
          this.target_throughput_bottom_reduced_speed_1_user_input = null;
        }
      }
    },
    closeDropdown() {
      this.hopperDropdownVisible = false;
      this.recipeDropdownVisible = false;
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
  height: 2.2rem;
  vertical-align: middle;
}

.table thead th {
  text-transform: none;
}

.table-input-cell {
  width: 3rem;
  padding: 0rem;
  height: 1.6rem;
  text-align: center;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: transparent;
  border: 1px solid #a7a7a7; /* lighter gray */
}
.container-fluid {
  padding-top: 20px;
}

.valid-row {
  background-color: #d4edda !important; /* green */
}
.accepted-row {
  background-color: #fff3cd !important; /* yellow */
}
.rejected-row {
  background-color: #f8d7da !important; /* red */
}

.color-legend {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.9rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.action-header {
  align-items: center;
}

.color-box {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 6px;
  border: 1px solid #ccc;
}
</style>
